import {replenishmentSCListUrl, inventoryQueryListUrl} from 'Utils/urlUtil';
import {callApi} from 'Utils/apiUtil';
import util from 'Utils/commonUtil';

export const PRODUCT_MANAGEMENT_SC_LIST = 'PRODUCT_MANAGEMENT_SC_LIST';
export const CONVERT_PRODUCT_INITIAL = 'CONVERT_PRODUCT_INITIAL';
export const CONVERT_PRODUCT_SUCCESS = 'CONVERT_PRODUCT_SUCCESS';
export const INVENTORY_QUERY_LIST = 'INVENTORY_QUERY_LIST';
export const INVENTORY_QUERY_LIST_INITIAL = 'INVENTORY_QUERY_LIST_INITIAL';
export const INVENTORY_QUERY_LIST_FAILURE = 'INVENTORY_QUERY_LIST_FAILURE';
export const INVENTORY_QUERY_MORE_INITIAL = 'INVENTORY_QUERY_MORE_INITIAL';
export const INVENTORY_QUERY_MORE_FAILURE = 'INVENTORY_QUERY_MORE_FAILURE';
export const INVENTORY_QUERY_MORE_SUCCESS = 'INVENTORY_QUERY_MORE_SUCCESS';

const abyss = (data, length) => {
    let showAbyss = false;
    if (util.isArray(data) && data.length < length) {
        showAbyss = true;
    }
    return showAbyss;
};

// Get SC list
export function getSCList(params, func) {
    const request = null;
    const options = {data: params};
    const success = (response) => ({
        type: PRODUCT_MANAGEMENT_SC_LIST,
        payload: response,
    });
    const failure = null;

    return callApi(
        replenishmentSCListUrl,
        options,
        request,
        success,
        failure,
        func,
    );
}

// Get inventory query list
export function getInventoryQueryList(params, func) {
    const request = () => ({
        type: INVENTORY_QUERY_LIST_INITIAL,
        payload: {
            inventoryQueryList: [],
            inventoryQueryListLoaded: false,
            inventoryQueryAbyss: false,
        },
    });
    const options = {data: params};
    const success = (response) => {
        return {
            type: INVENTORY_QUERY_LIST,
            payload: {
                inventoryQueryList: response,
                inventoryQueryListLoaded: true,
                inventoryAbyss: abyss(response.data, 10),
            },
        };
    };
    const failure = () => ({
        type: INVENTORY_QUERY_LIST_FAILURE,
        payload: {
            inventoryQueryList: [],
            inventoryQueryListLoaded: false,
            inventoryQueryAbyss: false,
        },
    });

    return callApi(
        inventoryQueryListUrl,
        options,
        request,
        success,
        failure,
        func,
    );
}

// Get more inventory query list
export function getMoregetInventoryQueryList(params) {
    return (dispatch, getState) => {
        const inventoryQuery = getState().inventoryQuery;

        const options = {
            data: params,
        };
        const request = () => ({
            type: INVENTORY_QUERY_MORE_INITIAL,
            payload: {
                inventoryQueryListLoaded: false,
                inventoryQueryLoadingMore: true,
                inventoryQueryAbyss: false,
            },
        });
        const failure = () => ({
            type: INVENTORY_QUERY_MORE_FAILURE,
            payload: {
                inventoryQueryListLoaded: true,
                inventoryQueryLoadingMore: false,
                inventoryQueryAbyss: true,
            },
        });
        const success = (response) => {
            const apiReponseData = response.data;
            const list = util.isArray(response.data)
                ? inventoryQuery.inventoryQueryList.data.concat(response.data)
                : [];
            response.data = list;

            return {
                type: INVENTORY_QUERY_MORE_SUCCESS,
                payload: {
                    inventoryQueryList: response,
                    inventoryQueryListLoaded: true,
                    inventoryQueryLoadingMore: false,
                    inventoryQueryAbyss: abyss(
                        apiReponseData,
                        inventoryQuery.inventoryQueryList.pageSize,
                    ),
                },
            };
        };

        return dispatch(
            callApi(inventoryQueryListUrl, options, request, success, failure),
        );
    };
}
